import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { getCookieDomain } from '../utils/login';
import prodConfig from './prod';
import testConfig from './test';
function isFeixiangLaoshiDomain() {
  return window.location.hostname.includes('feixianglaoshi');
}
function getProdConfig() {
  if (getCookieDomain().includes('top100school.com')) {
    return prodConfig.top100;
  }
  if (isFeixiangLaoshiDomain()) {
    return prodConfig.feixianglaoshi;
  }
  return prodConfig.feixiangxingqiu;
}
function getTestConfig() {
  if (isFeixiangLaoshiDomain()) {
    return testConfig.feixianglaoshi;
  }
  return testConfig.feixiangxingqiu;
}
var ENV = process.env.REACT_APP_ENV;
var config = function () {
  switch (ENV) {
    case 'online':
    case 'production':
      return _objectSpread({
        ENV: ENV
      }, getProdConfig());
    default:
      return _objectSpread({
        ENV: ENV
      }, getTestConfig());
  }
}();
export default config;